import React, {useEffect, useMemo, useRef, useState} from "react";
import {Box, Button, Checkbox, FormControlLabel} from "@mui/material";
import {Grid} from "@mui/system";
import ProgressBar from "./ProgressBar";
import StepOneForm from "./StepOneForm";
import Stepper from "./VerticalStepper";
import {isMobile, isTablet} from "react-device-detect";
import StepTwoForm from "./StepTwoForm";
import StepThreeForm from "./StepThreeForm";
import StepFourForm from "./StepFourForm";
import StepFiveForm from "./StepFiveForm";
import StepSixForm from "./StepSixForm";
import StepSevenForm from "./StepSevenForm";
import StepEightForm from "./StepEightForm";
import StepNineForm from "./StepNineForm";
import {useDispatch, useSelector} from "react-redux";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import {
  selectAuthState,
  setAuthData,
  setAuthState,
} from "../../../store/authSlice";
import StepTenForm from "./StepTenForm";
import GlobalModal from "../../global-fields/GlobalModal";
import {useNavigate} from "react-router-dom";
import {AGENT_CLIENTS, PROPOSAL_DETAILS} from "../../../constants/apiConstant";
import {selectUiState, setUiData} from "../../../store/uiSlice";
import {initialFormValidations, removeCookies} from "../../../constants/helper";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import style from "../../../assets/css/proposal.module.scss";
import {MdOutlineDone} from "react-icons/md";
import StepElevenForm from "./StepElevenForm";
import StepTwelveForm from "./StepTwelveForm";
import GlobalSelectField from "../../global-fields/GlobalSelectField";
import GlobalSearchField from "../../global-fields/GlobalSearchField";
import debounce from "lodash/debounce";
import ClientSelect from "../../client-select";
import Cookies from "js-cookie";

const NewProposalForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {user, agentClientsData, selectedClient} = useSelector(selectAuthState);
  const {proposalStep, proposal_id, previous_proposal_id, formValidations} =
    useSelector(selectDataStoreState);
  const leftGridRef = useRef(null);
  const [leftGridWidth, setLeftGridWidth] = useState(0);
  const [displayConsent, setDisplayConsent] = useState(false);
  const [Iagree, setIAgree] = useState(false);
  const {dynamicHeaderHeight} = useSelector(selectUiState);
  // const [digitalSigntaure, setDigitalSigntaure] = useState(false);
  const [digitalSigntaureCheck, setDigitalSigntaureCheck] = useState(true);
  // console.log("propStep1Data, propStep2Data, propStep3Data, propStep4Data, propStep5Data, propStep6Data, propStep7Data, propStep8Data, propStep9Data, propStep10Data",
  //     propStep1Data, propStep2Data, propStep3Data, propStep4Data, propStep5Data, propStep6Data, propStep7Data, propStep8Data, propStep9Data, propStep10Data
  // )
  const [signingUrl, setSigningUrl] = useState(null);
  // console.log("selectedClient", selectedClient);
  const [showPopup, setShowPopup] = useState(false);

  const fetchClients = async (searchTerm) => {
    dispatch(setUiData({showLoader: true}));

    const data = {
      agent_id: user?.id,
      limit: "10",
      offset: "0",
      search: searchTerm,
    };

    const options = {
      method: AGENT_CLIENTS.method,
      headers: AGENT_CLIENTS.headers,
      body: JSON.stringify(data),
    };

    fetch(AGENT_CLIENTS.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          GlobalNotificationPopup({type: "error", message: res?.message});
        } else if (res.status == 1) {
          dispatch(
            setAuthData({
              agentClientsData: res?.data?.data ?? [],
            })
          );
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
        }
      })
      .catch((error) => {
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        navigate("/");
      });
  };
  const fetchProposalDetails = async () => {
    dispatch(
      setUiData({
        showLoader: true,
      })
    );

    let data = {
      user_id: user?.id,
      proposal_id: proposal_id,
      step: proposalStep,
      previous_proposal_id: previous_proposal_id ?? null,
    };
    if (user?.user_type === "agent") {
      data = {...data, user_id: selectedClient?.user_id};
    }

    const options = {
      method: PROPOSAL_DETAILS.method,
      headers: PROPOSAL_DETAILS.headers,
      body: JSON.stringify(data),
    };

    await fetch(PROPOSAL_DETAILS.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
        } else if (res.status == 1) {
          // console.log("RESSSSSSSSSSS", res);
          const isArray = Array.isArray(res?.data);
          const isObjectWithData =
            typeof res?.data === "object" &&
            !isArray &&
            Object.keys(res?.data).length > 0;
          dispatch(
            setDataStore({
              [`propStep${proposalStep}Data`]: [],
            })
          );
          const notarr = [];
          const arr = [];
          for (let i = res?.step_status?.length - 1; i >= 0; i--) {
            if (res?.step_status[i]?.status === 0 && proposalStep - 1 > i) {
              notarr.push({
                ...res?.step_status[i],
                status: 2,
              });
            } else {
              arr.push(res?.step_status[i]);
            }
          }
          const merged = [...notarr, ...arr].sort((a, b) => a.step - b.step);
          dispatch(
            setDataStore({
              [`propStep${proposalStep}Data`]: isObjectWithData
                ? res?.data
                : null,
              formValidations: merged ?? initialFormValidations,
            })
          );
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
        }
      })
      .catch((error) => {
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        navigate("/");
      });
  };

  const updateWidth = () => {
    if (leftGridRef.current) {
      setLeftGridWidth(leftGridRef.current.offsetWidth);
    }
  };
  const isAgent = useMemo(() => user?.user_type === "agent", [user]);

  useEffect(() => {
    // Update width on mount and when window resizes
    const handleResize = () => updateWidth();
    handleResize(); // Initial call
    window.addEventListener("resize", handleResize);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // Navigate to client selection if user is an agent and no client is selected.
    // console.log("selectedClient", selectedClient,proposal_id , proposalStep)
    // if (user?.user_type === "agent" && selectedClient === null ) {
    //   navigate('/client-select');
    //   return;
    // }

    // Initialize proposal state if no proposal Number and at step 1
    if (proposal_id === null && proposalStep === 1) {
      const consentShown = Cookies.get("consent_shown");
      if (!consentShown) {
        setDisplayConsent(true);
        Cookies.set("consent_shown", "true", {expires: 365});
      }
      dispatch(
        setAuthData({user_type: user?.user_type === "agent" ? "agent" : ""})
      );

      // Reset proposal steps data
      for (let i = 1; i <= 12; i++) {
        dispatch(setDataStore({[`propStep${i}Data`]: null}));
      }
    }

    // Fetch proposal details if proposal Number and step are available
    if (proposal_id && proposalStep) {
      fetchProposalDetails();
    }
  }, [user, selectedClient, proposal_id, proposalStep]);

  // useEffect(() => {
  //   if (isAgent && selectedClient === null) {

  //     navigate('/client-select')
  //   }
  //   updateWidth();
  // }, [selectedClient]);
  // // console.log("isAgent",isAgent)
  // useEffect(() => {

  //   if (proposal_id === null && proposalStep === 1) {
  //     setDisplayConsent(true);
  //     if (isAgent) {
  //       //fetchClients();
  //       dispatch(setAuthData({ user_type: "agent" }));
  //     } else {
  //       dispatch(setAuthData({ user_type: "" }));
  //     }
  //     Array(10)
  //       .fill(null)
  //       .map((_, index) =>
  //         dispatch(setDataStore({ [`propStep${index + 1}Data`]: null }))
  //       );
  //   }

  //   // updateWidth();
  //   window.addEventListener("resize", updateWidth);
  //   return () => {
  //     window.removeEventListener("resize", updateWidth);
  //   };
  // }, []);

  // //const firstCall = useRef(false);

  // useEffect(() => {
  //   if (proposal_id && proposalStep) {
  //     // if (!firstCall.current && proposal_id) {
  //     // firstCall.current = true;
  //     fetchProposalDetails();
  //   }
  // }, [proposal_id, proposalStep]);

  const getStepComponent = (proposalStep, leftGridWidth) => {
    let width = leftGridWidth === 0 ? "100%" : leftGridWidth;
    switch (proposalStep) {
      case 1:
        return <StepOneForm leftGridWidth={width} />;
      case 2:
        return <StepTwoForm leftGridWidth={width} />;
      case 3:
        return <StepThreeForm leftGridWidth={width} />;
      case 4:
        return <StepFourForm leftGridWidth={width} />;
      case 5:
        return <StepFiveForm leftGridWidth={width} />;
      case 6:
        return <StepSixForm leftGridWidth={width} />;
      case 7:
        return <StepSevenForm leftGridWidth={width} />;
      case 8:
        return <StepEightForm leftGridWidth={width} />;
      case 9:
        return <StepNineForm leftGridWidth={width} />;
      case 10:
        return <StepTenForm leftGridWidth={width} />;
      case 11:
        return <StepElevenForm leftGridWidth={width} />;
      case 12:
        return <StepTwelveForm leftGridWidth={width} />;
      default:
        return null; // Handle invalid proposalStep values
    }
  };

  const CurrentStepCompo = getStepComponent(proposalStep, leftGridWidth);

  const handleConsent = () => {
    setDisplayConsent(false);
  };
  const handleConsentCancel = () => {
    setDisplayConsent(false);
    dispatch(
      setAuthData({
        selectedClient: null,
      })
    );
    navigate("/dashboard");
  };

  const handleSelectedClient = (e) => {
    let selectedId = e.target.value;
    const cli_ent = agentClientsData.find((c) => c?.user_id == selectedId);
    dispatch(
      setAuthData({
        selectedClient: cli_ent,
      })
    );
  };

  const handleClientSelectContinue = () => {
    setDisplayConsent(false);
  };

  return (
    <>
      {/* {isAgent && selectedClient === null ? <ClientSelect /> : */}
      {isAgent && selectedClient === null ? null : (
        <>
          {" "}
          <Grid container spacing={0}>
            <Grid ref={leftGridRef} item size={3} className="desktopStepper">
              <div
                className="side_f"
                style={{height: `calc(100vh - ${dynamicHeaderHeight + 50}px)`}}
              >
                <Stepper />
              </div>
            </Grid>

            <Grid size={{xs: 12, lg: 9, sm: 12, md: 12}}>
              <Box sx={{pl: 4, pr: 4, pt: 3}} className="MobileStepper">
                <ProgressBar current={proposalStep} total={12} />
              </Box>
              {CurrentStepCompo}
            </Grid>
          </Grid>
        </>
      )}

      {isAgent ? null : (
        <GlobalModal
          open={displayConsent}
          // open={true}
          maxWidth="md"
          handleClose={() => setDisplayConsent(false)}
          aria-labelledby="claim-history"
          closeIcon={false}
          title={"Consent"}
          dialogTitleClass={style.claimPopTitle}
          disableBackdropClick={true}
          dialogContent={
            <Grid container spacing={0}>
              <Grid size={{xs: 12, md: 12}}>
                <Box sx={{mb: 1}} className={style.consentContent}>
                  <ul>
                    <li>
                      <div>
                        {!Iagree ? (
                          <MdOutlineDone />
                        ) : (
                          <MdOutlineDone className={style.active} />
                        )}
                      </div>
                      <p>
                        This proposal and declaration must be completed and
                        signed digitally.
                      </p>
                    </li>
                    <li>
                      <div>
                        {!Iagree ? (
                          <MdOutlineDone />
                        ) : (
                          <MdOutlineDone className={style.active} />
                        )}
                      </div>
                      <p>
                        {/* One signed copy will be attached to the policy if
                        issued, together with any supplementary information,
                        which must also be in writing signed by the assured. */}
                        A signed copy will be attached to the policy, if issued,
                        along with any supplementary information, which must
                        also be signed in writing by the assured.
                      </p>
                    </li>
                    <li>
                      <div>
                        {!Iagree ? (
                          <MdOutlineDone />
                        ) : (
                          <MdOutlineDone className={style.active} />
                        )}
                      </div>
                      <p>
                        {/* It is essential that all questions be answered fully
                        giving details applicable to each location. */}
                        It is essential that all questions are answered fully
                        and accurately, providing details relevant to each
                        location.
                      </p>
                    </li>
                    <li>
                      <div>
                        {!Iagree ? (
                          <MdOutlineDone />
                        ) : (
                          <MdOutlineDone className={style.active} />
                        )}
                      </div>
                      <p>
                        {/* Quotations cannot be given on incomplete proposals. */}
                        Quotations will not be provided for incomplete
                        proposals.
                      </p>
                    </li>
                    <li>
                      <div>
                        {!Iagree ? (
                          <MdOutlineDone />
                        ) : (
                          <MdOutlineDone className={style.active} />
                        )}
                      </div>
                      <p>
                        {/* The answers to questions 2, 11a, 11c, 11d, 15d, must be
                        based on the 12 months period immediately preceding the
                        date of the proposal. */}
                        The answers to questions 2, 11a, 11c, 11d, and 15d must
                        reflect information from the 12-month period immediately
                        preceding the date of the proposal.
                      </p>
                    </li>
                    {/* <li>
                      <div>
                        {!Iagree ? <MdOutlineDone /> : <MdOutlineDone className={style.active} />}
                      </div>
                      <p>If the answer to any question is none state “none” or “nil”</p>
                    </li> */}
                  </ul>

                  <Box className={style.ConsentAgree}>
                    <FormControlLabel
                      sx={{width: "auto"}}
                      control={
                        <Checkbox
                          value={Iagree}
                          onChange={(e) => {
                            setIAgree(e.target.checked);
                          }}
                        />
                      }
                      label="I agree to all of the above points."
                    />
                  </Box>
                </Box>
              </Grid>

              <Grid
                size={{xs: 12, md: 12}}
                sx={{textAlign: "center"}}
                className={style.consentContentBtn}
              >
                <Button
                  variant="contained"
                  sx={{mr: 1}}
                  onClick={handleConsentCancel}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={handleConsent}
                  disabled={!Iagree}
                >
                  Continue
                </Button>
              </Grid>
            </Grid>
          }
        ></GlobalModal>
      )}
    </>
  );
};

export default NewProposalForm;
